import React, { Dispatch, SetStateAction, useMemo, useState } from "react";
import { Button, CircularProgress, Stack, Typography } from "@mui/material";
import { GroupType } from "../../../types/group.type";
import ModalExportExcelForList from "../../../components/common/modal/ModalExportExcelForList";

interface IOptions {
  group: GroupType;
  query?: { [key: string]: any };
  totalRows?: number;
  setLoad: Dispatch<SetStateAction<number>>;
}

const limit = 500;

function Options({ group, query, totalRows = 0, setLoad }: IOptions) {
  const [openExportExcel, setOpenExportExcel] = useState(false);
  const [loadingExport, setLoadingExport] = useState<boolean>(false);

  const maxPage = useMemo(() => {
    let result = 1;
    if (totalRows % limit > 0) {
      result += 1;
    }
    return result;
  }, [totalRows]);

  return (
    <>
      {openExportExcel && (
        <ModalExportExcelForList
          files={maxPage}
          condition={{
            limit,
            q: query,
          }}
          loading={loadingExport}
          setLoading={setLoadingExport}
          open={openExportExcel}
          handleClose={() => setOpenExportExcel(false)}
          apiCode={group?.apiCodeList}
          filenameExport={`${group?.apiCodeList}_export.xlsx`}
        />
      )}
      {loadingExport && (
        <Stack
          direction="row"
          alignItems="center"
          gap={1}
          sx={{
            position: "fixed",
            zIndex: 100,
            bottom: 0,
            right: "5%",
            px: 2,
            py: 1,
            backgroundColor: "secondary.main",
            borderRadius: "10px 10px 0px 0px",
          }}
        >
          <Typography sx={{ color: "common.white" }}>
            Xuất {`${group?.apiCodeList}_export.xlsx`}
          </Typography>
          <CircularProgress
            style={{ width: "20px", height: "20px" }}
            sx={{ color: "common.white" }}
          />
        </Stack>
      )}
      {/* Button */}
      <Button
        onClick={() => setOpenExportExcel(true)}
        variant="contained"
        color="primary"
        size="small"
        sx={{
          boxShadow: "none",
          color: "common.white",
          textTransform: "none",
          "&:hover": { boxShadow: "none" },
        }}
      >
        Xuất excel
      </Button>
    </>
  );
}

export default Options;
